module.exports = __webpack_public_path__ + "static/bio-1a90adb3d42be8be8375e4f51c17c359.jpg";